export const EXPRESS_ORDER_STORE_ID_COOKIE = 'EXPRESS_ORDER_STORE_ID';

export const EXPRESS_ORDER_STORE_ID_CHANGED_EVENT = 'express-order-store-id-changed';
